export default {
  root: {
    // width: 20,
    // height: 20
  }
};
